import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { STATUS_CODE_200 } from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import "./index.css";

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  titleStyle,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      <input
        className="custom-radio"
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
      />
      <p style={{ ...titleStyle }}>{title}</p>
    </div>
  );
};

const AddSecurityDetailsModal = ({ onClickCancel, data }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState("");
  const [utr, setUtr] = useState("");
  const [selectedType, setSelectedType] = useState("ROLLING");
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    border: "0px",
    marginBottom: 20,
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };

  const updateClientSecurityDeposit = () => {
    if (!value) {
      enqueueSnackbar("Please enter details", {
        variant: "error",
      });
      return false;
    }

    if (selectedType === "DEPOSIT" && !utr) {
      enqueueSnackbar("Please enter bank utr", {
        variant: "error",
      });
      return false;
    }

    ApiRequestPost.editClientUser({
      securityAmount: selectedType === "DEPOSIT" ? value : "",
      reservePercentage: selectedType === "ROLLING" ? value : "",
      securityStatus: selectedType === "DEPOSIT",
      reserveStatus: selectedType === "ROLLING",
      userId: data?.userId,
      userRefId: data?.userRefId,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/clients");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",

          maxWidth: 500,
          minWidth: 300,
        }}
      >
        <div style={{ display: "flex", gap: 15, margin: "20px 0px" }}>
          <RadioButton
            onChange={(val) => {
              setSelectedType(val.target.value);
              setValue("");
            }}
            titleStyle={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#001053",
              opacity: selectedType === "ROLLING" ? 1 : 0.6,
              marginLeft: "10px",
            }}
            defaultChecked={selectedType === "ROLLING"}
            id="ROLLING"
            name="Rolling_Reserve"
            title="Rolling Reserve"
            value="ROLLING"
          />
          <RadioButton
            onChange={(val) => {
              setSelectedType(val.target.value);
              setValue("");
            }}
            titleStyle={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#001053",
              opacity: selectedType === "DEPOSIT" ? 1 : 0.6,
              marginLeft: "10px",
            }}
            defaultChecked={selectedType === "DEPOSIT"}
            id="DEPOSIT"
            name="Security_Deposit"
            title="Security Deposit"
            value="DEPOSIT"
          />
        </div>{" "}
        <p style={{ fontSize: 13, marginBottom: 5 }}>
          {selectedType === "DEPOSIT"
            ? "Enter Security Deposit"
            : "Enter Rolling Reserve"}
        </p>
        <div
          style={{
            display: "flex",
            gap: 10,
          }}
        >
          <div
            style={{
              height: "50px",
              width: "50px",
              backgroundColor: "#F3F3F3",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p>{selectedType === "DEPOSIT" ? "₹" : "%"}</p>
          </div>
          <CustomInput
            validator={"paise"}
            onChange={(e) => setValue(e)}
            value={value}
            type={"input"}
            placeholder={selectedType === "DEPOSIT" ? "Enter Amount" : "10"}
            inputStyles={{
              ...inputStyle,
            }}
          />
        </div>
        {selectedType === "DEPOSIT" && (
          <>
            <p style={{ fontSize: 13, marginBottom: 5 }}>Enter the UTR</p>
            <CustomInput
              value={utr}
              onChange={(e) => setUtr(e)}
              placeholder="Bank Utr"
              inputStyles={{
                ...inputStyle,
              }}
              type="input"
              containerStyles={{
                ...containerStyle,
              }}
            />
          </>
        )}
        <div
          style={{
            display: "flex",
            gap: 20,
            justifyContent: "center",
          }}
        >
          <CustomButton
            title="Cancel"
            styles={{
              backgroundColor: colorWhite,
              border: "1px solid black",
              padding: 0,
              height: "auto",
              padding: "10px",
            }}
            textStyles={{
              color: colorBlack,
            }}
            onClick={onClickCancel}
          />
          <CustomButton
            title={"Save"}
            styles={{
              backgroundColor: primaryColor,
              border: `1px solid ${primaryColor}`,
              marginLeft: "20px",
              width: "120px",
            }}
            onClick={() => {
              updateClientSecurityDeposit();
            }}
            textStyles={{ color: "white" }}
          />
        </div>
      </div>
    </>
  );
};

export default AddSecurityDetailsModal;
